/**
 * Name of the events that the library will trigger on the document object during its lifetime.
 * @remarks
 * Warning : These strings are used in Google Tag Manager!
 */
export enum DataSyncLibEventNames {
  /**
   * This event is triggered once the library is loaded but hasn't been initialized yet.
   */
  LibraryLoaded = "gtmDataSyncLib_loaded",

  /**
   * This event is triggered once the user has been initialized from the UIE.
   */
  UserInitialized = "gtmDataSyncLib_userInitialized",

  /**
   * This event is triggered once the library is loaded, the UIE has been called and the CDP profile
   * is correctly setup.
   */
  CdpProfileSetup = "gtmDataSyncLib_cdpProfileSetup",

  /**
   * This event is triggered when a change in user consent preferences has been detected and processed
   * by the library.
   */
  ConsentChangeHandled = "gtmDataSyncLib_consentChangedHandled",

  /**
   * This event is triggered once the library is loaded and a profile is loaded.
   * This event should occur only once per page load (and not on each page view).
   */
  LotameServiceInitialized = "gtmDataSyncLib_lotameServiceInitialized",

  /**
   * This event is triggered each time Lotame's profile is loaded or updated.
   * Should occur once on page load and each subsequent page view.
   */
  LotameProfileUpdated = "gtmDataSyncLib_lotameProfileUpdated",

  /**
   * This event is triggered when the geolocation data as been resolved, successfully or not.
   */
  GeolocationDataLoaded = "gtmDataSyncLib_geolocationDataLoaded",
}
